import { FC } from 'react';
import { DialogContentText, Slider } from '@mui/material';

const EditBusinessPriorityContent: FC<
  React.PropsWithChildren<EditBusinessPriorityContentProps>
> = ({ value, onChange, error }) => {
  return (
    <>
      <DialogContentText>
        You may set a new Business Priority (BP) between 0 and 100. The higher
        the BP the more prominent the issues in the application will be relative
        to applications with lower BP and vice-versa. Once changed, OX will no
        longer dynamically determine the BP.
      </DialogContentText>
      <Slider
        sx={{ mt: 4 }}
        value={value}
        valueLabelDisplay='on'
        min={0}
        max={100}
        onChange={onChange}
      />
    </>
  );
};

export interface EditBusinessPriorityContentProps {
  value: number;
  onChange: (event: Event, value: number | number[]) => void;
  error?: boolean;
}

export default EditBusinessPriorityContent;
